module.exports = __webpack_public_path__ + "static/media/android-youtube-player_300px.9f66fcf4.webp";